/**
 * @generated SignedSource<<8cde8dd775affe71ea773c9e809a3a75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ManageSpaceShortcutModal_space$data = {
  readonly __typename: "Space";
  readonly id: string;
  readonly " $fragmentType": "ManageSpaceShortcutModal_space";
};
export type ManageSpaceShortcutModal_space$key = {
  readonly " $data"?: ManageSpaceShortcutModal_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"ManageSpaceShortcutModal_space">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ManageSpaceShortcutModal_space",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Space",
  "abstractKey": null
};

(node as any).hash = "ff173e197eb4a0c74aea98d0e5a9bff6";

export default node;
